import React from 'react';
import { ClockIcon, FlowerIcon, GemIcon, LanguagesIcon, WrenchIcon } from 'lucide-react';
import { BalloonIcon } from '../shared/BalloonIcon';
import { Reveal } from '../shared/Reveal';
import { SectionHeading } from '../shared/SectionHeading';
import { useLanguage } from '../../contexts/LanguageContext';
const icons = [WrenchIcon, ClockIcon, LanguagesIcon, GemIcon];
export function WhyUs() {
  const {
    t
  } = useLanguage();
  const w = t.home.why;
  return <section aria-labelledby="why-title" className="bg-cream py-20 sm:py-24" data-id="element-111" data-mp="1q0elz6lef496">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-112" data-mp="1l4z9oj31hgev">
        <Reveal data-id="element-113" data-mp="1zsu3k2ss9qtj">
          <SectionHeading eyebrow={w.eyebrow} id="why-title" title={w.title} data-id="element-114" data-mp="1ztdjxf2sc75g" />
        </Reveal>

        <div className="mt-12 grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-115" data-mp="1v0kgcuj1z4uy">
          <Reveal className="lg:col-span-5" data-id="element-116" data-mp="17brgwo382evl">
            <div className="flex h-full flex-col rounded-3xl bg-mauve-deep p-8 text-white sm:p-10" data-id="element-117" data-mp="17aq1k7f6b682">
              <div className="flex items-center gap-2 text-champagne" aria-hidden="true" data-id="element-118" data-mp="12ceuu5k6dbu2">
                <FlowerIcon className="h-8 w-8" data-id="element-119" data-mp="z1u9jvri11bf" />
                <span className="text-xl text-white/40" data-id="element-120" data-mp="1347fola5r18q">+</span>
                <BalloonIcon className="h-8 w-8" data-id="element-121" data-mp="132nv4ihgy415" />
              </div>
              <h3 className="mt-8 font-display text-3xl font-semibold" data-id="element-122" data-mp="17unv2axjgwxq">{w.lead.title}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-white/80" data-id="element-123" data-mp="1cua5kclzfz2u">{w.lead.body}</p>
            </div>
          </Reveal>

          <ul className="grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:col-span-7 lg:self-center" data-id="element-124" data-mp="g5ca0s6erx4m">
            {w.items.map((item, i) => {
            const Icon = icons[i];
            return <li key={item.title} className="border-t border-mauve/15 pt-6" data-id="element-125" data-mp="p3o6hatyhp4z" data-mpi={i}>
                  <Icon className="h-6 w-6 text-mauve" aria-hidden="true" data-id="element-126" data-mp="u4kcbtxvbld1" />
                  <h3 className="mt-4 font-display text-xl font-semibold text-ink" data-id="element-127" data-mp="20juzfqjocgqw">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-128" data-mp="25ifu7ag5q87y">{item.body}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}